import { Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { requestoauthApi } from "../services/authApi"
import { useState, useEffect } from "react";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import SaveIcon from '@mui/icons-material/Save';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import GoogleIcon from '@mui/icons-material/Google';

const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "95%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));

const RegisterGmail = ({ registerGmailClick, loginGmailClick }) => {


  return (<>
    <Box sx={{ textAlign: "center", width: "95%" }} >
      <Divider textAlign="center">
        <Chip label="ثبت نام / ورود به برنامه  با Gmail" color="success" icon={<LockOpenIcon />} />
      </Divider>
      <DemoPaper sx={{ my: .5 }} elevation={3} variant="elevation">
        <Button
          onClick={registerGmailClick}
          sx={{ m: .5 }} variant="contained" endIcon={<GoogleIcon />}>ثبت نام در برنامه</Button>
        <Button
          onClick={loginGmailClick}
          sx={{ m: .5 }} variant="contained" endIcon={<GoogleIcon />}>ورود به برنامه </Button>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button variant="contained">
            برگشت به صفحه اصلی
          </Button>
        </Link>
      </DemoPaper>
    </Box>
  </>)
}


export default RegisterGmail;
